import { render, staticRenderFns } from "./mcqCard.vue?vue&type=template&id=4613a84b&scoped=true"
import script from "./mcqCard.vue?vue&type=script&lang=js"
export * from "./mcqCard.vue?vue&type=script&lang=js"
import style0 from "./mcqCard.vue?vue&type=style&index=0&id=4613a84b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613a84b",
  null
  
)

export default component.exports